module.exports = __webpack_public_path__ + "img/gather sleeve ruffle.0a22431b.png";